import { post } from "@utils/httpUtil";
//标签管理
export function commonLabelGetList(data, config) {
  return post(`/c/pc/common/label/getList`, data, config);
}
export function commonLabelGetPageInfo(data, config) {
  return post(`/c/pc/common/label/getPageInfo`, data, config);
}
export function commonLabelDelete(data, config) {
  return post(`/c/pc/common/label/labelDelete`, data, config);
}
export function commonLabelSaveOrUpdate(data, config) {
  return post(`/c/pc/common/label/saveOrUpdate`, data, config);
}
// 医生列表标签处理
//批量打标签
export function doctorListBatchAddLabel(data, config) {
  return post(`/c/pc/community/doctor/v2/batchAddLabel`, data, config);
}
//修改标签
export function doctorListUpdateLabel(data, config) {
  return post(`/c/pc/community/doctor/updateLabel`, data, config);
}
// 用户列表标签处理
//批量打标签
export function userListBatchAddLabel(data, config) {
  return post(`/c/pc/community/user/v2/batchAddLabel`, data, config);
}
//修改标签
export function userListUpdateLabel(data, config) {
  return post(`/c/pc/community/user/updateLabel`, data, config);
}